<template>
  <el-dialog
    title="备忘录"
    :visible.sync="panelShow"
    width="800px"
    custom-class="memorandum-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div class="memorandum-panel-main">
      <div class="memorandum-panel-side">
        <div class="memorandum-add-btn" @click="toAddMemo">
          <span>新增备忘录+</span>
        </div>
        <el-scrollbar class="memorandum-list">
          <ul style="margin: 0;padding: 0;" v-infinite-scroll="getMemoPage">
            <li class="memorandum-item" :class="{ 'memorandum-item-active': form.id == item.id }" v-for="item in memoList" :key="item.id" @click="selectMemorandum(item)">
              <div style="width: 100%">
                <div class="memorandum-item-title">{{ item.name || '无标题' }}...</div>
                <div class="memorandum-item-status">
                  <span v-if="item.status == 'M01'" class="status-text status-todo">待执行</span>
                  <span v-else-if="item.status == 'M09'" class="status-text status-done">已完成</span>
                  <i class="el-icon-download icon-top" v-if="item.top == '1'"></i>
                </div>
              </div>
            </li>
          </ul>

        </el-scrollbar>
      </div>
      <div class="memorandum-panel-content">
        <div class="memorandum-panel-toolbar" v-if="form.id">
          <div class="memorandum-status-container">
            <div class="status-badge" :class="{'status-todo': form.status == 'M01', 'status-done': form.status == 'M09'}" @click="toSetStatus">
              {{ form.status == 'M01' ? '待执行' : (form.status == 'M09' ? '已完成' : '选择状态') }}
            </div>
            <transition name="el-zoom-in-top">
              <div class="status-panel" v-show="statusPanelShow">
                <div class="status-item status-todo-item" @click="setStatus('M01')">待执行</div>
                <div class="status-item status-done-item" @click="setStatus('M09')">已完成</div>
              </div>
            </transition>
          </div>
        </div>
        <div class="memorandum-editor-container">
          <Editor
            v-model="form.content"
            class="memorandum-editor"
            :disabled="!canEdit"
          />
        </div>

        <div class="memorandum-editor-footer">
          <div class="memorandum-actions" v-if="canEdit">
            <span class="action-btn primary" @click="saveMemo">保存</span>
            <template v-if="form.id">
              <span class="action-btn danger" @click="delMemo">删除</span>
              <span class="action-btn primary" @click="setTop(1)" v-if="form.top == '0'">置顶</span>
              <span class="action-btn primary" @click="setTop(0)" v-else>取消置顶</span>
            </template>
          </div>
          <div class="memorandum-info" v-if="form.id">创建者：{{ form.userName }} 更新于：{{ parseTime(form.updatedTime) }}</div>
        </div>
        <div class="memorandum-panel-share">
          <template v-if="canEdit">
            <span class="share-label">分享给：</span>
            <div class="share-selector">
              <div class="shared-input" @click="showSharePanel">
                <div class="shared-row">
                  <template v-for="(item,index) in shareUserList">
                    <div class="shared-item" :key="index" v-if="item.checked">{{ item.realName }}</div>
                  </template>
                </div>
                <span class="input-arrow">
                  <i class="el-icon-arrow-up" v-if="sharePanelShow"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </span>
              </div>
              <transition name="el-zoom-in-bottom">
                <div class="share-panel" v-show="sharePanelShow" @click.stop="() => {}">
                  <el-scrollbar class="share-list">
                    <div class="share-item-row header-row" v-if="shareUserList.length">
                      <span class="share-item-col">
                        <el-input v-model="shareSearchKey" placeholder="输入用户名称筛选" size="small"></el-input>
                      </span>
                    </div>
                    <div class="share-item-row" v-if="!shareSearchKey && shareUserList.length">
                      <span class="share-item-col">
                        <el-checkbox v-model="isSelectAll" @change="selectAll"/>&nbsp;全选
                      </span>
                    </div>
                    <template v-for="(item,index) in shareUserList">
                      <div class="share-item-row" :key="index" v-if="(item.realName || '').includes(shareSearchKey)">
                        <div class="share-item-col name-col">
                          <el-checkbox v-model="item.checked" @change="selectShareUser"/>&nbsp;{{ item.realName }}
                        </div>
                        <div class="share-item-col status-col">
                          <span class="status-dot enabled" v-if="item.enabled == '1'"></span>
                          <span class="status-dot disabled" v-else></span>
                          {{ item.enabled == '1' ? '启用' : '停用' }}
                        </div>
                      </div>
                    </template>
                  </el-scrollbar>
                </div>
              </transition>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="memorandum-mask" v-if="sharePanelShow || statusPanelShow" @click="closeInnerPanel"></div>
  </el-dialog>
</template>

<script>
import Editor from '@/components/Editor'
import memoApi from '@/api/memo/memo'
import entUserApi from '@/api/entUser/entUser'
import { parseTime } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  components: {
    Editor
  },
  data() {
    return {
      form: {
        id: '',
        content: '',
        shareUserList: []
      },
      saveLoading: false,

      queryParams: {
        page: 0,
        size: 10,
        total: 0,
      },
      memoList: [
      ],
      memoListLoading: false,
      shareUserList: [
      ],
      panelShow: false,
      suspendingBtnShow: true,
      sharePanelShow: false,
      statusPanelShow: false,

      isSelectAll: false,

      waitDealCount: 0,

      canEdit: true,

      shareSearchKey: ''
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.getMemoPage()
  },
  methods: {
    parseTime,
    closeInnerPanel() {
      this.statusPanelShow = false
      this.sharePanelShow = false
    },
    selectMemorandum(row) {
      this.canEdit = row.canEdit
      this.getMemoDetail(row.id)
      this.sharePanelShow = false
    },
    showPanel() {
      this.suspendingBtnShow = false
      this.getMemoPage('refresh')
      this.getShareUserList()
      // setTimeout(() => {
      this.panelShow = true
      // }, 200)
    },
    onClose() {
      this.closeInnerPanel()
    },
    /**
     * 获取分页
     */
    getMemoPage(type = 'load') {
      if (type == 'refresh') {
        this.queryParams.page = 0
      }
      this.memoListLoading = true
      let params = {
        page: this.queryParams.page + 1,
        size: this.queryParams.size
      }
      memoApi.getPage(params).then(res => {
        if (res.records) {
          if (type == 'refresh') {
            this.memoList = res.records
          }
          else {
            this.memoList = [...this.memoList,...res.records]
          }
          if (res.records.length) {
            this.queryParams.page = res.page
          }
          this.queryParams.total = res.totalCount
        }
        this.waitDealCount = res.statistics
        this.$emit('update:count', this.waitDealCount)
        this.memoListLoading = false
      }).catch(error => {
        this.memoListLoading = false
      })
    },
    /**
     * 获取用户列表
     */
    getShareUserList() {
      entUserApi.getUserPage({ size: 9999 }).then(res => {
        this.shareUserList = (res.records || []).filter(item => {
          item.checked = false
          return item.id != this.user.id
        })
      }).catch(error => {})
    },
    showSharePanel() {
      this.sharePanelShow = !this.sharePanelShow
    },
    closeSharePanel() {
      this.sharePanelShow = false
    },
    /**
     * 新增
     */
    toAddMemo() {
      this.form = {
        "content": "",
        "id": null,
        "name": "",
        "shareUserList": [
          {
            "userId": 0,
            "userName": ""
          }
        ],
      }
      this.shareUserList.forEach(item => {
        item.checked = false
      })
      this.isSelectAll = false
      this.canEdit = true
    },
    /**
     * 保存
     */
    saveMemo() {
      if (!(this.form.content.replace(/&nbsp;/gi, '').replace(/\s/g, ""))) return this.$message.error('请输入内容')
      this.saveLoading = true
      this.form.name = this.form.content.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, '').replace(/\s/g, "").substring(0, 5)
      this.form.shareUserList = this.shareUserList.filter(item => item.checked).map(item => {
        return {
          userId: item.id,
          userName: item.realName
        }
      })
      memoApi.save(this.form).then(res => {
        this.getMemoPage('refresh')
        this.saveLoading = false
        this.$message.success('保存成功')
        this.selectMemorandum({id: res, canEdit: true})
      }).catch(error => {
        this.saveLoading = false
      })
    },
    /**
     * 获取详情
     */
    getMemoDetail(id) {
      memoApi.getDetail(id).then(res => {
        this.form = res || {}
        const ids = this.form.shareUserList.map(item => item.userId)
        this.isSelectAll = true
        this.shareUserList.forEach(item => {
          item.checked = ids.includes(item.id)
          if (!item.checked) {
            this.isSelectAll = false
          }
        })
      }).catch(error => {})
    },
    /**
     * 置顶/取消置顶
     */
    setTop(optType) {
      memoApi.setTop({
        memoBookId: this.form.id,
        optType
      }).then(res => {
        this.getMemoDetail(this.form.id)
        this.getMemoPage('refresh')
      }).catch(error => {})
    },
    /**
     * 删除
     */
    delMemo() {
      memoApi.del(this.form.id).then(res => {
        this.getMemoPage('refresh')
        this.toAddMemo()
      }).catch(error => {})
    },
    /**
     * 设置状态
     */
    toSetStatus() {
      if (this.canEdit) {
        this.statusPanelShow = !this.statusPanelShow
      }
    },
    setStatus(status) {
      memoApi.setStatus({
        memoBookId: this.form.id,
        status
      }).then(res => {
        this.getMemoDetail(this.form.id)
        this.getMemoPage('refresh')
        this.statusPanelShow = false
      }).catch(error => {})
    },
    selectAll() {
      this.shareUserList.forEach(item => item.checked = this.isSelectAll)
    },
    selectShareUser(row) {
      this.isSelectAll = this.shareUserList.every(item => item.checked)
    }
  }

}
</script>

<style lang="scss" scoped>
.memorandum-list,.share-list {
  &/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.icon-top {
  transform: rotate(180deg);
  margin-left: 5px;
  color: #288cff;
}

.memorandum-mask {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 2000;
}

.memorandum-panel-main {
  display: flex;
  height: 550px;
  border-top: 1px solid #eee;

  .memorandum-panel-side {
    width: 200px;
    border-right: 1px solid #eee;
    background-color: #fff;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;

    .memorandum-add-btn {
      width: 100%;
      height: 50px;
      padding: 0 15px;
      display: flex;
      font-size: 14px;
      justify-content: flex-start;
      align-items: center;
      color: #288cff;
      cursor: pointer;
      font-weight: 500;
      &:hover {
        background-color: #f5f7fa;
      }
    }
    .memorandum-list {
      flex: 1;
      overflow: hidden;
      font-size: 14px;
      .memorandum-item {
        width: 100%;
        padding: 12px 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
        color: #333;
        transition: background-color 0.2s;

        .memorandum-item-title {
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 6px;
        }

        .memorandum-item-status {
          display: flex;
          align-items: center;
          font-size: 12px;

          .status-text {
            &.status-todo { color: #f56c6c; }
            &.status-done { color: #67c23a; }
          }
        }
      }

      .memorandum-item:hover {
        background-color: #f5f7fa;
      }
      .memorandum-item-active {
        background-color: #f0f2f5;
        border-left: 3px solid #288cff;
        padding-left: 12px;
      }
    }
  }

  .memorandum-panel-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .memorandum-panel-toolbar {
      display: flex;
      background-color: #fff;
      height: 50px;
      padding: 0 20px;
      align-items: center;
      border-bottom: 1px solid #f0f0f0;

      .memorandum-status-container {
        position: relative;

        .status-badge {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 12px;
          color: #fff;
          font-size: 12px;
          cursor: pointer;
          user-select: none;
          background-color: #909399; /* Default */

          &.status-todo { background-color: #f56c6c; }
          &.status-done { background-color: #67c23a; }
        }

        .status-panel {
          position: absolute;
          top: 30px;
          left: 0;
          width: 100px;
          background: #fff;
          z-index: 2001;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          border: 1px solid #ebeef5;
          border-radius: 4px;
          padding: 5px 0;

          .status-item {
            padding: 8px 15px;
            font-size: 13px;
            cursor: pointer;
            &:hover { background-color: #f5f7fa; }

            &.status-todo-item { color: #f56c6c; }
            &.status-done-item { color: #67c23a; }
          }
        }
      }
    }

    .memorandum-editor-container {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 0 10px;

      .memorandum-editor {
        height: 100%;
        overflow: hidden;
        color: #000;
        /deep/.w-e-text-container {
          background-color: #fff;
          border: none !important;
          height: 100% !important;
        }
        /deep/ .w-e-toolbar {
          border: none !important;
          background-color: #fff !important;
        }
      }
    }

    .memorandum-editor-footer {
      background-color: #fff;
      height: 50px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      align-items: center;
      font-size: 14px;

      .memorandum-actions {
        display: flex;
        gap: 15px;

        .action-btn {
          cursor: pointer;
          font-size: 14px;

          &.primary { color: #288cff; }
          &.danger { color: #f56c6c; }

          &:hover { opacity: 0.8; }
        }
      }

      .memorandum-info {
        font-size: 12px;
        color: #909399;
      }
    }

    .memorandum-panel-share {
      background-color: #f9fafc;
      height: 60px;
      padding: 0 20px;
      font-size: 14px;
      display: flex;
      align-items: center;
      border-top: 1px solid #eee;

      .share-label {
        color: #606266;
        margin-right: 10px;
      }
    }
  }
}

.share-selector {
  position: relative;
  flex: 1;

  .shared-input {
    width: 100%;
    max-width: 400px;
    height: 36px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 13px;
    background-color: #fff;
    transition: border-color 0.2s;

    &:hover {
      border-color: #c0c4cc;
    }

    .shared-row {
      display: flex;
      align-items: center;
      flex: 1;
      overflow: hidden;
      .shared-item {
        max-width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #606266;
        background-color: #f0f2f5;
        padding: 2px 8px;
        margin-right: 5px;
        border-radius: 2px;
        font-size: 12px;
      }
    }

    .input-arrow {
      color: #c0c4cc;
    }
  }

  .share-panel {
    position: absolute;
    bottom: 45px;
    left: 0;
    width: 400px;
    max-height: 300px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border: 1px solid #ebeef5;
    z-index: 2001;
    border-radius: 4px;

    .share-list {
      height: 250px;
      padding: 10px;

      .share-item-row {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid #f5f7fa;

        &.header-row {
          padding-bottom: 10px;
          border-bottom: 1px solid #ebeef5;
        }

        &:last-child {
          border-bottom: none;
        }

        .share-item-col {
          display: flex;
          align-items: center;

          &.name-col { flex: 2; }
          &.status-col {
            flex: 1;
            justify-content: flex-end;
            font-size: 12px;
            color: #909399;
          }

          .status-dot {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 5px;

            &.enabled { background-color: #67c23a; }
            &.disabled { background-color: #f56c6c; }
          }
        }
      }
    }
  }
}

/deep/ .el-dialog__body {
  padding: 0;
}
</style>
